import React from 'react';
import { 
  LayoutDashboard, 
  Shield, 
  Users, 
  Database, 
  Bell, 
  Server,
  Settings,
  Building
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const SuperAdminNav: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { 
      title: 'Dashboard', 
      icon: LayoutDashboard, 
      path: '/admin/dashboard',
      description: 'Overview and statistics'
    },
    { 
      title: 'User Management', 
      icon: Users, 
      path: '/admin/users',
      description: 'Manage user roles and access'
    },
    { 
      title: 'Properties', 
      icon: Building, 
      path: '/admin/properties',
      description: 'Manage properties'
    },
    { 
      title: 'Security Center', 
      icon: Shield, 
      path: '/admin/security',
      description: 'Security and compliance'
    },
    { 
      title: 'Database', 
      icon: Database, 
      path: '/admin/database',
      description: 'Database operations'
    },
    { 
      title: 'System Health', 
      icon: Server, 
      path: '/admin/health',
      description: 'Monitor system performance'
    },
    { 
      title: 'Notifications', 
      icon: Bell, 
      path: '/admin/notifications',
      description: 'System notifications'
    },
    { 
      title: 'Settings', 
      icon: Settings, 
      path: '/admin/settings',
      description: 'System configuration'
    }
  ];

  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <nav className="space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPath.startsWith(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-purple-50 text-purple-700'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon className={`h-5 w-5 ${isActive ? 'text-purple-500' : 'text-gray-400'}`} />
              <div className="ml-3 flex-1">
                <p className={`text-sm font-medium ${isActive ? 'text-purple-700' : 'text-gray-900'}`}>
                  {item.title}
                </p>
                <p className={`text-xs ${isActive ? 'text-purple-600' : 'text-gray-500'}`}>
                  {item.description}
                </p>
              </div>
              {isActive && (
                <div className="w-1.5 h-8 bg-purple-500 rounded-full ml-4"></div>
              )}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default SuperAdminNav;